import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

interface RichTextEditorProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

const TOOLBAR_MODULES = {
  toolbar: [['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }]],
}

const ALLOWED_FORMATS = ['bold', 'italic', 'list', 'bullet']

export function RichTextEditor({
  value,
  onChange,
  placeholder,
  className,
}: RichTextEditorProps) {
  const quillRef = useRef<ReactQuill>(null)
  const [localValue, setLocalValue] = useState(value)
  const isInternalChange = useRef(false)

  useEffect(() => {
    if (!isInternalChange.current) {
      setLocalValue(value)
    }
    isInternalChange.current = false
  }, [value])

  const handleChange = useCallback(
    (content: string) => {
      isInternalChange.current = true
      setLocalValue(content)
      onChange(content)
    },
    [onChange],
  )

  const modules = useMemo(() => TOOLBAR_MODULES, [])

  return (
    <div className={`gw-rich-text-editor${className ? ` ${className}` : ''}`}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={localValue}
        onChange={handleChange}
        modules={modules}
        formats={ALLOWED_FORMATS}
        placeholder={placeholder}
      />
    </div>
  )
}

export default RichTextEditor
